export default __webpack_public_path__ + "static/media/hemsruti2.b363bf0d.jpeg";